/* eslint-disable */
function map(k, f) {
    return {
        width: f(k.width),
        height: f(k.height),
    };
}

function scale(k, s) {
    return map(k, v => v * s);
}

function diff(m, n) {
    return {
        width: m.width - n.width,
        height: m.height - n.height,
    };
}

function isEqual(m, n) {
    return m.width === n.width && m.height === n.height;
}

function toPoint(s) {
    return {
        x: s.width,
        y: s.height,
    };
}

export const Size = {
    scale,
    diff,
    isEqual,
    toPoint,
};
